module.exports = __webpack_public_path__ + "img/format_color_reset.b3f31442.svg";